import apiClient from '@/api/apiClient';
import { handleError, getAuthData, prepareModel } from '../../utils/storeHelpers';

export default {
  namespaced: true,
  state: {
    schema: {},
    modelForm: {},
    isNewRecord: true,
    status: '',
  },

  getters: {
    schema: (state) => state.schema,
    modelForm: (state) => state.modelForm,
    isNewRecord: (state) => state.isNewRecord,
    status: (state) => state.status,
  },

  mutations: {
    SET_SCHEMA(state, schema) {
      state.schema = schema;
    },
    SET_RECORDS(state, { recordsData }) {
      state.modelForm = typeof recordsData?.modelForm === 'object' ? recordsData.modelForm : {};
      state.isNewRecord = Boolean(recordsData?.isNewRecord);
    },
    SET_STATUS(state, status) {
      state.status = status;
    },
  },

  actions: {
    async fetchSchema({ commit }) {
      try {
        commit('SET_STATUS', 'loading');
        const responses = await Promise.all([
          apiClient.caxAFSMxPhysicalCondSchema(),
          apiClient.catPhysicComplexion(),
          apiClient.catPhysicVestment(),
          apiClient.catPhysicCleanliness(),
          apiClient.catPhysicVestmentColor(),
        ]);
        const [
          schemaRes,
          catPhysicComplexion,
          catPhysicVestment,
          catPhysicCleanliness,
          catPhysicVestmentColor,
        ] = responses.map((res) => res?.data ?? {});

        if (!schemaRes.schemaForm) throw new Error('Estructura de schema inválida.');

        const schema = structuredClone(schemaRes);
        schema.schemaForm.group1.schema.physic_complexion_id.items = catPhysicComplexion.data ?? [];
        schema.schemaForm.group1.schema.physic_vestment_id.items = catPhysicVestment.data ?? [];
        schema.schemaForm.group1.schema.physic_cleanliness_id.items =
          catPhysicCleanliness.data ?? [];
        schema.schemaForm.group2.schema.physic_vestment_color_id.items =
          catPhysicVestmentColor.data ?? [];
        commit('SET_SCHEMA', schema);
      } catch (error) {
        handleError(error, commit);
      }
    },

    async fetchRecords({ commit, rootState }) {
      try {
        const { clinicalHistories_id, institutions_profes_id } = getAuthData(rootState);
        const res = await apiClient.modelCAxAFSMxPhysicalCond(clinicalHistories_id, institutions_profes_id);
        const recordsData = res?.data?.data ?? {};
        commit('SET_RECORDS', { recordsData });
        commit('SET_STATUS', 'loaded');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async createRecord({ commit, rootState }, { model }) {
      try {
        commit('SET_STATUS', 'create');
        const preparedModel = prepareModel(rootState, model);
        await apiClient.createCAxAFSMxPhysicalCond(preparedModel);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async updateRecord({ commit, rootState }, { model }) {
      try {
        commit('SET_STATUS', 'update');
        const preparedModel = prepareModel(rootState, model);
        const id = preparedModel.modelForm.physical_condition_id;
        await apiClient.updateCAxAFSMxPhysicalCond(id, preparedModel);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },
  },
};
